import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import styled from 'styled-components';
import { Constants } from '../utils/Constants';
import Patient, { PatientEmbed } from './Patient';
import { FillingForm } from './forms/filling/FillingForm';
import { ProfileCardSection } from './messages/ProfileCardSection';
//`${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => '0px'};
  width: 100%;
  padding-bottom: 0;
  max-width: 100%;
  max-height: 100vh;
  height: 100vh;
  overflow: 'hidden'
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px 8px ${Constants.OUTLETS_PADDING}px ${Constants.OUTLETS_PADDING}px`};
  padding-top: 0;
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  max-width: initial;
  /* padding-bottom: 0; */
  }
`

const PatientDetailsContainer = styled(Flex)`
  display: none;
  @media screen and (min-width: 1380px) {
    display: flex;
    min-width: 600px;
    max-width: 600px;
  }
`

const FlexForm = styled(Flex)`
  width: 100%;
  @media screen and (min-width: 1380px) {
    width: calc(100% - 500px);
  }
`

const PatientDetailsFloatingContainer = styled(Flex)`
  display: flex;
  z-index: 10;
  @media screen and (min-width: 1380px) {
    display: none;
  }
`
interface INewNoteProps {
}

export const NewNote: React.FC<INewNoteProps> = ({ }) => {
  let { id, frmId } = useParams();
  console.log({ id, frmId })
  if(!id || !frmId) {
    return <Text>Invalid URL</Text>
  }
  return (
    <Container id='aall' flexDirection={'row'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <FlexForm mt={`${Constants.OUTLETS_PADDING_TOP}px`} flexDirection={'column'}>
        {!frmId ? (
          <Text textAlign={'center'}>An error occured</Text>
        ) : (
          <FillingForm formId={frmId} athenaId={id}/>
        )}
      </FlexForm>

      <PatientDetailsFloatingContainer id='pcs0'>
          <ProfileCardSection athenaId={id} />
      </PatientDetailsFloatingContainer>
      <PatientDetailsContainer id='ptEmbed'>
          <Box style={{ height: '100vh', flex: 1, position: 'sticky', top: 0 }}>
            <Box style={{ height: '100%', background: '#C0CDEC', flex: 1, borderRadius: '20px' }}>
              <PatientEmbed athenaId={id} />
            </Box>
          </Box>
        </PatientDetailsContainer>
      {/* <Box style={{ height: '100vh', flex: 1, padding: '0 0 12px 24px', position: 'sticky', top: 0, width:'600px', minWidth:'600px', maxWidth: '600px' }}>
        <Box style={{ height: '100%', background: '#C0CDEC', flex: 1, borderRadius: '20px' }}>
          <Patient isMinimized={true} />
        </Box>
      </Box> */}
    </Container>);
}